import { ParticipantsPersonApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useParticipantsPersonApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new ParticipantsPersonApi(configuration),
    [configuration]
  );
};
